import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getCoachLeadInbox, updateCoachProviderLead } from '../lib/coachLeads';
import type { TenantCoachLeadInboxResponse, TenantCoachLeadUpdatePayload } from '../types';

export const coachLeadKeys = {
  all: ['coach-leads'] as const,
  inbox: () => [...coachLeadKeys.all, 'inbox'] as const,
};

export function useCoachLeadInbox(enabled: boolean = true) {
  return useQuery<TenantCoachLeadInboxResponse>({
    queryKey: coachLeadKeys.inbox(),
    queryFn: getCoachLeadInbox,
    staleTime: 30 * 1000,
    retry: false,
    enabled,
  });
}

export function useUpdateCoachProviderLead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ requestId, payload }: { requestId: number; payload: TenantCoachLeadUpdatePayload }) =>
      updateCoachProviderLead(requestId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: coachLeadKeys.inbox() });
    },
  });
}
